import { Button, Col, Modal, Row } from "react-bootstrap";
import { ProdutoNFCeDto } from "../NFCe.Dto";

interface ProdutoNFCePropriedadesProps {
  show: boolean;
  onCancel: () => void;
  onDelete: (value: ProdutoNFCeDto) => void;
  produto: ProdutoNFCeDto | undefined;
}

export const NFCeModalItemPropriedadesView = ({
  show,
  onCancel,
  onDelete,
  produto,
}: ProdutoNFCePropriedadesProps) => {
  const onDeleteHandler = () => {
    if (produto) {
      onCancel();
      onDelete(produto);
    }
  };

  return (
    <>
      <Modal show={show} centered>
        <Modal.Body>
          <Row>
            <Col>
              {produto?.nome}[{produto?.codigoProduto}]
            </Col>
          </Row>
          <Row>
            <Col xs={6}>Quantidade: {produto?.quantidadeComercial}</Col>
            <Col xs={6}>
              Valor Unitário:{" "}
              {produto?.valorUnitarioComercial
                ? produto.valorUnitarioComercial.toFixed(2).replace(".", ",")
                : "0,00"}
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              Valor Total:{" "}
              {produto?.valorUnitarioComercial && produto.quantidadeComercial
                ? (produto.valorUnitarioComercial * produto.quantidadeComercial)
                    .toFixed(2)
                    .replace(".", ",")
                : "0,00"}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onCancel}>Voltar</Button>
          <Button
            variant="outline-danger"
            className="messagebox-btn-cancel"
            onClick={onDeleteHandler}
          >
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
